import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import { useContext, useState } from "react";
import FileUploader from "../../../../@ui/FileUploader";
import { LayerImportState } from "../../../../constant/LayerImportState";
import { LayerContext } from "../LayerContext";
import ImportTable from "../ImportTable/ImportTable";
import { useMrnService } from "../../../../hooks";

const MrnLayer = () => {
  const mrnService = useMrnService();
  const [importFile, setImportFile] = useState<File | null>(null);
  const [revertInProgress, setRevertInProgress] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);

  const value = useContext(LayerContext);
  const { layerInfo, setImportPage } = value!;

  const onUpload = () => {
    setUploadingFile(true);
    if (importFile) {
      mrnService
        .Import(importFile)
        .then(() => {
          setUploadingFile(false);
        })
        .catch(() => {});
    }
  };

  const onClear = () => {
    setImportFile(null);
  };

  const onRevert = () => {
    setRevertInProgress(true);
    mrnService
      .Revert()
      .then(() => {
        setImportPage(1);
        setRevertInProgress(false);
      })
      .catch(() => {});
  };

  return (
    <div className="h-100 w-100 position-relative">
      <Stack gap={4} className="mb-3">
        <Row>
          <Col sm={6}>
            <Row>
              <Form.Label>Upload data for new import</Form.Label>
            </Row>
            <Row>
              <FileUploader
                onClear={onClear}
                onUpload={onUpload}
                onChange={setImportFile}
                disableButtons={!importFile}
                loading={uploadingFile}
              />
            </Row>
          </Col>
          <Col sm={6}>
            <Row>
              <Form.Label>
                {layerInfo.revertToImportDate && (
                  <>
                    Rollback to import{" "}
                    {layerInfo.revertToImportDate.toFormat("dd-MM-yyyy")}
                  </>
                )}
                {!layerInfo.revertToImportDate && <>Rollback Unavailable</>}
              </Form.Label>
              <div>
                <Button
                  disabled={
                    !layerInfo.revertToImportDate ||
                    revertInProgress ||
                    uploadingFile
                  }
                  onClick={() => onRevert()}
                  className="w-50">
                  Rollback
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      </Stack>
      <ImportTable />
    </div>
  );
};

export default MrnLayer;
